import { FullPurchaseOrderInfo, usePurchaseOrdersList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type PurchaseOrderAutocompleteProps = Omit<
  AutocompleteFieldProps<FullPurchaseOrderInfo>,
  'options' | 'defaultValue'
> & {
  defaultValue?: FullPurchaseOrderInfo['id'];
};

export const PurchaseOrderAutocomplete = ({ defaultValue, ...props }: PurchaseOrderAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = usePurchaseOrdersList({
    search: query,
  });

  return (
    <AutocompleteField<FullPurchaseOrderInfo>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => item.slug}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      data-testid="purchase-order-autocomplete"
      {...props}
    />
  );
};
